import { LoadState } from "../../constants/enums";
import moment from "moment";

import {
  IPaymentDetails,
  IPaymentDetailsState,
  IPaymentOverview,
} from "./paymentDetails.types";

export const initialPaymentDetails: IPaymentDetails = {
  leads_uuid: "",
  amount: "0",
  payment_transaction_uuid: null,
  tax_amount_percentage: "0",
  mode_of_payment: "VENDOR_PAYMENT",
  status: "ACTIVE",
  company_outlet_uuid: "",
  payment_date: moment().format("YYYY-MM-DD"),
  remarks: "",
  transaction_effect: "+",
  payment_type: "TRANSACTION",
  tax_amount: "0",
  effective_amount: "0",
  billing_to: "DIRECT",
  cancellation_dead_reason: null,
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const initialPaymentOverview: IPaymentOverview = {
  OUTSTANDING_BTC: "0.00",
  OUTSTANDING_DIRECT: "0.00",
  OUTSTANDING_BTC_THIS_MONTH: "0.00",
  OUTSTANDING_DIRECT_THIS_MONTH: "0.00",
  TOTAL_OUTSTANDING_THIS_MONTH: "0.00",
  TOTAL_OUTSTANDING_ALL_TIME: "0.00",
  PAST_DUE_BTC: "0.00",
  PAST_DUE_DIRECT: "0.00",
  CURRENT_MONTH_REVENUE: "0.00",
  UPCOMING_BTC: "0.00",
  UPCOMING_DIRECT: "0.00",
};

export const initialPaymentDetailsState: IPaymentDetailsState = {
  list: {
    list: [],

    loading: LoadState.NotLoaded,
    error: null,
  },
  Payment_list: {
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  data: {
    data: initialPaymentDetails,
    loading: LoadState.NotLoaded,
    error: null,
  },
  overview: {
    data: initialPaymentOverview,
    loading: LoadState.NotLoaded,
    error: null,
  },
  recordCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  pastPaymentStatusCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  paymentList: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
